/**
 * Represents the Platform of App.
 */
export const enum Platform {
  MOBILE = 'mobile',
  WEB = 'web',
  TABLET = 'tablet',
}

export const enum ScreenLayoutEnum {
  MOBILE = 'mobile',
  TABLET = 'tablet',
  DESKTOP = 'desktop',
}

export type ScreenLayoutType = {
  /**
   * screen width
   */
  width: number;
  /**
   * screen height
   */
  height: number;
  /**
   * screen attributes
   */
  attributes: {
    /**
     * screen actions
     */
    actions:  Record<string, any>;
    /**
     * status bar style
     */
    statusBarStyle: string;
    /**
     * background color
     */
    backgroundColor: string;
    reverseScroll: boolean;
  };
}

/**
 * Represents the Visibility of App.
 */
export const enum Visibility {
  VIEW = 'view',
  SCREENS = 'screens',
  DATA = 'data',
}

/**
 * Represents the AppType of App.
 */
export const enum AppType {
  TEST = 'test',
  RELEASE = 'release',
}

/**
 * Represents the AppVersion of App.
 */
export const enum AppVersion {
  V1 = 'v1',
  V2 = 'v2',
  V3 = 'v3',
}

/**
 * Represents the AppVersion of App.
 */
export const enum Template {
  FACEBOOK = 'facebook',
  BASIC = 'basic',
  MESSAGES = 'messages',
  EDITOR = 'editor',
  DELETE = 'delete',
  CART = 'cart',
  SEARCH = 'search',
  FAVORITE = 'favorite',
  POST = 'post',
  POST_PHOTO = 'postPhoto',
  LIKE = 'like',
  DATA_TYPE = 'dataType',
  DATA_EDITING = 'dataEditing',
  HANDLE_DATA = 'handleData',
  PAGE_CONTROL = 'pageControl',
  APPLICATION = 'application',
}

/**
 * Represents App.
 */
export interface BaseApp {
  /** The owner Id of App */
  ownerId: number;

  /** The App's name
   * - maxLength: 500
   */
  name: string;

  /** The UUID for App
   * - maxLength: 100
   */
  appId: string;

  /**
   * workspace Id of App
   */
  workspaceId: string;

  /** The id of app share database
   * - maxLength: 100
   */
  shareDatabaseAppId: string;

  /** The description of APP
   * - maxLength: 1000
   */
  description: string;

  /** The App's icon
   * - maxLength: 500
   */
  icon: string;

  /** The App's Team ID */
  teamId: number;

  /** Setting primary color's app
   * - default value: "#000000"
   */
  primaryColor: string;

  /** Setting secondary color's app
   * - default value: "#000000"
   */
  secondaryColor: string;

  /** Setting default background color's app
   * - default value: "#F9FBFC"
   */
  backgroundColor: string;

  /** Setting default text color's app
   * - default value: "#1A2737"
   */
  textColor: string;

  /** The template Id of App */
  templateId: number;

  /** The App's metadata */
  metadata: string;

  /** The App's cookie */
  cookie: string;

  /** The App's session */
  appleSession: string;

  /** The App's certificate. It's used to build app */
  certificatePath: string;

  /** The status public of app */
  public: boolean;

  /** The App's tag */
  tags: Array<string>;

  /** The App's thumbnails */
  thumbnails: Array<string>;

  /** The number of click App */
  numberOfClick: number;

  /** Check status newVersion App, use in V2 */
  newVersion: boolean;

  /** The App's platform */
  platform: Platform;

  /** The App's visibility */
  visibility: Visibility | null;

  /** The App's subDomain */
  subDomain: string | null;

  /** The App's custom Domain */
  customDomain: string | null;

  /** The status of App's delete */
  isDeleted: boolean;

  /** The account connect of App */
  accountConnectId?: string;

  /** The App's type */
  appType: AppType;

  /** The App's version */
  version: AppVersion;

  /** The App's deleted at */
  deletedAt?: number | null;

  /** The App's created at */
  createdAt: number | null;

  /** The App's updated at */
  updatedAt: number | null;

  /** The App's template */
  template?: Template;

  /** If true, the app will not have pages and tables. */
  isBlank?: boolean;
}

export type App = BaseApp & {
  /** The App's id. */
  id: number;
};
